import axios from 'axios';
import React, { useEffect, useState } from 'react';
import './style.css'
import { useNavigate, useParams } from 'react-router-dom';
import ModalUker from '../component/ModalUker/ModalUker';

export default function MKiosKejati() {
    const { uker } = useParams();

    const navigate = useNavigate();

    const overlayStyle = {
        position: 'absolute',           // Absolutely position the overlay on top of the background
        top: '150px',
        left: 0,
        right: 0,
        bottom: '150px',
        backgroundImage: 'url(../assets/logo/logo-kejati.png)', // Your overlay image (could be different)
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        opacity: 0.1,                   // Set opacity for transparency (0 is fully transparent, 1 is opaque)
        pointerEvents: 'none',
    };

    const [unitKerja, setUnitKerja] = useState(uker ?? -1);
    const [unitKerjaSelected, setUnitKerjaSelected] = useState(null);
    const [optionKerja, setOptionUnitKerja] = useState([]);
    const [isModalKerjaOpen, setModalKerjaOpen] = useState(false);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_UKER = "api/kejati/reservation/subproject";

    const fetchData = async (url, headers) => {
        try {
            const response = await axios.get(url, { headers });
            return response.data;
        } catch (err) {
            // setError("Gagal memuat data. Silakan coba lagi.");
            return null;
        }
    };

    useEffect(() => {
        if (unitKerja == -1) {
            setModalKerjaOpen(true);
        }
    }, [unitKerja]);

    // useEffect(() => {
    //     if (unitKerjaSelected) {
    //         navigate(`${window.location.pathname}/${unitKerjaSelected.id}`, { replace: true });
    //     }
    // }, [unitKerjaSelected]);

    useEffect(() => {
        if (optionKerja.length > 0) {
            setUnitKerjaSelected(optionKerja.find((option) => option.id === uker));
        }
    }, [uker, optionKerja])


    useEffect(() => {
        fetchData(`${BASE_URL}${PATH_UKER}`).then((response) => {
            setOptionUnitKerja(response);
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    if (loading) {
        return (
            <div className="loading-container">
                <div className="spinner"></div>
                <p>Loading...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="error-container">
                <p className="error-message">Error: {error.message}</p>
            </div>
        );
    }

    return (
        <div>
            <div style={overlayStyle}></div>

            <ModalUker
                show={isModalKerjaOpen}
                data={optionKerja}
                onClose={() => setModalKerjaOpen(false)}
                onChange={(value) => {
                    setUnitKerjaSelected(optionKerja.find((option) => option.id === value));
                    setUnitKerja(value);
                    setModalKerjaOpen(false);
                }} />

            <h1 className='text-center m-5 h1 font-bold text-5xl'>Selamat Datang di MKios</h1>
            <h1 className='text-center m-5 h1 text-5xl font-extralight'>{unitKerjaSelected?.name}</h1>

            <div className="flex justify-center items-center min-h-screen">
                <div className="text-center">
                    <div className="flex flex-col gap-8 mt-8">
                        <a href={`/mkios-reservation-checking/${unitKerja}`} >
                        {/* className="link-item" */}
                            <div className="flex flex-col items-center">
                                <img src="/assets/kejati/icon-taking-goods.png" alt="Image description" className="w-64 h-64" />
                                <p>Pengambilan Berkas</p>
                            </div>
                        </a>
                        <a href={`/mkios-new-queue-online/${unitKerja}`}>
                        {/* className="link-item" */}
                            <div className="flex flex-col items-center">
                                <img src="/assets/kejati/icon-online-delivery.png" alt="Pengantaran Pesanan Online" className="w-64 h-64" />
                                <p>Pengantaran Pesanan Online</p>
                            </div>
                        </a>
                        <a href={`/mkios-new-queue/${unitKerja}`}>
                        {/* className="link-item" */}
                            <div className="flex flex-col items-center">
                                <img src="/assets/kejati/icon-delivery.png" alt="Pengantaran Berkas" className="w-64 h-64" />
                                <p>Pengantaran Berkas</p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}
